import React, {memo} from "react";

export const IconContractDocuments = memo(({color, addClass}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
    >
      <path
        d="M14.5 20H1.5C0.673 20 0 19.327 0 18.5V2.5C0 1.673 0.673 1 1.5 1H14.5C15.327 1 16 1.673 16 2.5V4.5C16 4.776 15.776 5 15.5 5C15.224 5 15 4.776 15 4.5V2.5C15 2.224 14.776 2 14.5 2H1.5C1.224 2 1 2.224 1 2.5V18.5C1 18.776 1.224 19 1.5 19H14.5C14.776 19 15 18.776 15 18.5V14.5C15 14.224 15.224 14 15.5 14C15.776 14 16 14.224 16 14.5V18.5C16 19.327 15.327 20 14.5 20Z"
        fill={color || "black"}
      />
      <path
        d="M10.5 5H3.5C3.224 5 3 4.776 3 4.5C3 4.224 3.224 4 3.5 4H10.5C10.776 4 11 4.224 11 4.5C11 4.776 10.776 5 10.5 5Z"
        fill={color || "black"}
      />
      <path
        d="M12.5 7H3.5C3.224 7 3 6.776 3 6.5C3 6.224 3.224 6 3.5 6H12.5C12.776 6 13 6.224 13 6.5C13 6.776 12.776 7 12.5 7Z"
        fill={color || "black"}
      />
      <path
        d="M11.5 9H3.5C3.224 9 3 8.776 3 8.5C3 8.224 3.224 8 3.5 8H11.5C11.776 8 12 8.224 12 8.5C12 8.776 11.776 9 11.5 9Z"
        fill={color || "black"}
      />
      <path
        d="M8.5 11H3.5C3.224 11 3 10.776 3 10.5C3 10.224 3.224 10 3.5 10H8.5C8.776 10 9 10.224 9 10.5C9 10.776 8.776 11 8.5 11Z"
        fill={color || "black"}
      />
      <path
        d="M8.49977 17C8.36577 17 8.23477 16.946 8.13977 16.847C8.01577 16.719 7.96977 16.534 8.01877 16.363L9.01877 12.863C9.04177 12.781 9.08577 12.707 9.14577 12.647L16.6458 5.14698C16.8408 4.95198 17.1578 4.95198 17.3528 5.14698L19.8528 7.64698C20.0468 7.84098 20.0478 8.15498 19.8558 8.35098L12.3558 15.992C12.2908 16.058 12.2088 16.105 12.1178 16.127L8.61777 16.986C8.57877 16.996 8.53877 17 8.49877 17H8.49977ZM9.94477 13.262L9.21677 15.809L11.7418 15.189L18.7948 8.00298L16.9988 6.20698L9.94377 13.262H9.94477Z"
        fill={color || "black"}
      />
      <path
        d="M6.5 17H3.5C3.224 17 3 16.776 3 16.5C3 16.224 3.224 16 3.5 16H6.5C6.776 16 7 16.224 7 16.5C7 16.776 6.776 17 6.5 17Z"
        fill={color || "black"}
      />
    </svg>
  );
});
